<h1 mat-dialog-title>Project Uploads</h1>
<mat-dialog-content class="my-2">
  @if (loading) {
    <div class="text-center">
      <div class="row gx-0">
        <mat-spinner class="mx-auto"></mat-spinner>
      </div>
      <div class="row gx-0 pt-3">
        <span>Finding uploads...</span>
      </div>
    </div>
  } @else {
    @if (uploads.data.length === 0) {
      <div class="row gx-0 justify-content-center">
        <div class="col-auto">
          No active uploads
        </div>
      </div>
    } @else {
      <div class="row gx-0">
        <table mat-table [dataSource]="uploads" matSort>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Project Name(s)</th>
            <td mat-cell *matCellDef="let element">{{element.name ?? element.id}}</td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Upload State</th>
            <td mat-cell *matCellDef="let element">
              @if (element.state === 0) {Initialising}
              @if (element.state === 1) {Processing}
              @if (element.state === 2) {Complete}
              @if (element.state === 3) {Failed}
            </td>
          </ng-container>

          <ng-container matColumnDef="percent">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Progress</th>
            <td mat-cell *matCellDef="let element">{{element.percent | number:'1.1-1'}}%</td>
          </ng-container>

          <ng-container matColumnDef="stage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Stage Description</th>
            <td mat-cell *matCellDef="let element">{{element.stage}}</td>
          </ng-container>

          <ng-container matColumnDef="controls">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element">
              <div class="btn-group" role="group">
                <button class="btn-row mat-ctrlkey-orange me-1" mat-mini-fab aria-label="Stop upload"
                  (click)="stopUpload(element)" matTooltip="Stop upload">
                  <mat-icon>stop</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="dispCols"></tr>
          <tr mat-row *matRowDef="let row; columns: dispCols;"></tr>
        </table>
      </div>
    }
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="outlined" (click)="close()">Close</button>
</mat-dialog-actions>
